import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './baseQuery';

export const leaderboardApi = createApi({
  reducerPath: 'leaderboardApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['Leaderboard'],
  endpoints: (builder) => ({
    getTopByMinutes: builder.query({
      query: ({ period = 'current_month', limit = 100, offset = 0 } = {}) => ({
        url: '/leaderboard/minutes',
        params: { period, limit, offset },
      }),
      providesTags: ['Leaderboard'],
    }),
  }),
});

export const { useGetTopByMinutesQuery } = leaderboardApi;
